// This function is just a canary to check that everything is building properly.

export const canary = () => {
  return true;
};
